import { createBrowserHistory } from 'history';

const myhistory = createBrowserHistory();
export default myhistory